<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122 106" fill="none">
    <path
      d="M49.7419 19.5C54.7456 10.8333 67.2548 10.8333 72.2585 19.5L110.364 85.5C115.367 94.1667 109.113 105 99.1053 105H22.8951C12.8877 105 6.63305 94.1667 11.6367 85.5L49.7419 19.5Z"
      fill="#252525"
    />
    <path
      d="M55.3976 46.6331C55.1827 43.5883 57.5948 41 60.6471 41C63.6995 41 66.1116 43.5884 65.8967 46.6331L64.274 69.6206C64.1396 71.5246 62.5558 73.0005 60.6471 73.0005C58.7384 73.0005 57.1547 71.5246 57.0203 69.6206L55.3976 46.6331Z"
      fill="white"
    />
    <circle cx="60.6474" cy="84.2929" r="4.70595" fill="white" />
  </svg>
</template>
